<div class="form-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        {{ isEditMode ? 'Edit Garment' : 'Create New Garment' }}
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="garmentForm" (ngSubmit)="onSubmit()">

        <div class="image-section">

          <div class="image-preview">
            @if (displayedImageLinkOrB64) {
            <img [src]="displayedImageLinkOrB64" alt="Garment image" class="garment-image">
            } @else {
            <div class="image-placeholder">
              <mat-icon>checkroom</mat-icon>
              <p>No image</p>
            </div>
            }
          </div>

          @if (originalImage1 || newImageFile) {
          <div class="image-status">
            <mat-chip-set>
              @if (originalImage1 && !newImageFile) {
              <mat-chip color="primary">
                <mat-icon>check_circle</mat-icon>
                Current Image
              </mat-chip>
              }
              @if (newImageFile) {
              <mat-chip color="accent">
                <mat-icon>fiber_new</mat-icon>
                New Image Selected
              </mat-chip>
              }
            </mat-chip-set>
          </div>
          }

          <div class="image-actions">
            <input type="file" id="imageInput" (change)="onFileSelected($event)" accept="image/*"
              style="display: none;">

            <button mat-raised-button type="button" (click)="triggerFileInput()"
              [disabled]="isUploadingImage || isLoading">
              <mat-icon>photo_camera</mat-icon>
              {{ newImageFile ? 'Change Photo' : 'Choose Photo' }}
            </button>
            @if (newImageFile) {
            <button mat-raised-button type="button" color="warn" (click)="removeNewImage()"
              [disabled]="!newImageFile || isUploadingImage || isLoading">
              <mat-icon>close</mat-icon>
              Remove New
            </button>
            }
            
            @if (displayedImageLinkOrB64) {
            <button mat-raised-button type="button" color="accent" (click)="classifyImage()"
              [disabled]="isUploadingImage || isLoading">
              <mat-icon>whatshot</mat-icon>
              Classify
            </button>
            }

          </div>

          @if (newImageFile) {
          <p class="image-hint">
            <mat-icon>info</mat-icon>
            New image will replace the current one when you save
          </p>
          }

        </div>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" placeholder="Enter garment name">
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Description</mat-label>
          <textarea matInput formControlName="description" placeholder="Enter description" rows="3"></textarea>
        </mat-form-field>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <!-- todo: temporary ui. ... or permanent. better to use custom because the html one has varied support -->
            <mat-label>Color</mat-label>
            <input matInput formControlName="hex" placeholder="#000000" type="color">
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <!-- todo: https://material.angular.dev/components/datepicker/overview -->
            <mat-label>Last Worn</mat-label>
            <input matInput formControlName="last_worn" type="date">
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Gender</mat-label>
            <mat-select formControlName="gender_id">
              <mat-option [value]="null"></mat-option>
              @for (gender of genders; track gender.id) {
              <mat-option [value]="gender.id" [matTooltip]="gender.description || gender.name">
                {{ gender.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Master Category</mat-label>
            <mat-select formControlName="category_master_id">
              <mat-option [value]="null"></mat-option>
              @for (category of masterCategories; track category.id) {
              <mat-option [value]="category.id" [matTooltip]="category.description || category.name">
                {{ category.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Sub Category</mat-label>
            <mat-select formControlName="category_sub_id">
              <mat-option [value]="null"></mat-option>
              @for (category of subCategories; track category.id) {
              <mat-option [value]="category.id" [matTooltip]="category.description || category.name">
                {{ category.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Garment Type</mat-label>
            <mat-select formControlName="garment_type_id">
              <mat-option [value]="null"></mat-option>
              @for (type of garmentTypes; track type.id) {
              <mat-option [value]="type.id" [matTooltip]="type.description || type.name">
                {{ type.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Color</mat-label>
            <mat-select formControlName="color_id">
              <mat-option [value]="null"></mat-option>
              @for (color of colors; track color.id) {
              <mat-option [value]="color.id" [matTooltip]="color.description || color.name">
                <span class="color-option">
                  <span class="color-swatch" [style.background-color]="color.hex || '#ccc'"></span>
                  {{ color.name }}
                </span>
              </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Season</mat-label>
            <mat-select formControlName="season_id">
              <mat-option [value]="null"></mat-option>
              @for (season of seasons; track season.id) {
              <mat-option [value]="season.id" [matTooltip]="season.description || season.name">
                {{ season.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Usage</mat-label>
            <mat-select formControlName="usage_id">
              <mat-option [value]="null"></mat-option>
              @for (usage of usages; track usage.id) {
              <mat-option [value]="usage.id" [matTooltip]="usage.description || usage.name">
                {{ usage.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="button-row">

          @if (isEditMode) {
          <button mat-raised-button type="button" color="warn" [disabled]="isLoading || isUploadingImage"
            (click)="onDelete()">
            Delete
          </button>
          }

          <button mat-raised-button type="button" (click)="onCancel()"
            [disabled]="isLoading || isUploadingImage">Cancel</button>

          <button mat-raised-button color="primary" type="submit" [disabled]="isLoading || isUploadingImage">
            @if (isLoading || isUploadingImage) { <mat-spinner diameter="20"></mat-spinner> }
            @if (!isLoading && !isUploadingImage) { {{ isEditMode ? 'Update' : 'Create' }} }
          </button>



        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>